/* =========================================================
   MR Header — mega menu, collection → products, search,
   country/currency auto-detect, mobile drawer.
   No dependencies.
   ========================================================= */
(function () {
  'use strict';

  var GEO_KEY = 'mrh-geo-v1';           // set once auto-detect ran or visitor chose manually
  var productCache = new Map();         // url -> Promise<string html>

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(op, k, v) {
    try { return op === 'get' ? localStorage.getItem(k) : localStorage.setItem(k, v); } catch (e) { return null; }
  }
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- money formatting for predictive search ---------- */
  function formatMoney(amount, format) {
    var n = parseFloat(amount);
    if (isNaN(n)) return amount;
    format = format || '$' + '{{amount}}';
    function delim(num, dec, th, sep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(n, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(n, 2, "'", '.');
        case 'amount_with_space_separator': return delim(n, 2, ' ', ',');
        default: return delim(n, 2, ',', '.');
      }
    });
  }
  function decodeHtml(s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- products via Section Rendering API ---------- */
  function fetchProducts(url, sectionId) {
    if (productCache.has(url)) return productCache.get(url);
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    var p = fetch(u, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-mrh-products-list]');
        return list ? list.outerHTML : '';
      })
      .catch(function () { productCache.delete(url); return ''; });
    productCache.set(url, p);
    return p;
  }

  function MrHeader(root) {
    this.root = root;
    this.sectionId = root.dataset.productsSection || 'mr-header-products';
    this.limit = parseInt(root.dataset.productsLimit, 10) || 7;
    this.openKey = null;
    this.timers = {};
    this.reqToken = 0;
    this.init();
  }

  MrHeader.prototype.init = function () {
    this.setupScroll();
    this.setupMega();
    this.setupDropdowns();
    this.setupGeo();
    this.setupSearch();
    this.setupDrawer();
    this.setupCart();
    this.setupCardActions();
    this.setupLocation();
  };

  /* ---------- sticky / compact bar ---------- */
  MrHeader.prototype.setupScroll = function () {
    var self = this, root = this.root, mode = root.dataset.sticky;
    if (mode !== 'compact') return;
    var wrap = root.parentElement, full = 0, compact = false, ticking = false, lastY = 0;
    function measure() {
      if (compact) return;
      full = root.offsetHeight;
      wrap.style.minHeight = full + 'px';
    }
    function update() {
      ticking = false;
      var y = Math.max(window.scrollY || window.pageYOffset || 0, lastY);
      if (!compact && y > full + 40) {
        compact = true; root.classList.add('is-compact'); self.close(); self.closeDropdowns(); self.closeSearch && self.closeSearch();
      } else if (compact && y < Math.max(full - 20, 0)) {
        compact = false; root.classList.remove('is-compact'); self.close(); self.closeDropdowns(); self.closeSearch && self.closeSearch(); measure();
      }
    }
    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', function () { measure(); update(); }, { passive: true });
    document.addEventListener('scroll', function (e) { var t = e.target; lastY = (t && t !== document && t.contains && t.contains(root)) ? t.scrollTop : 0; if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true, capture: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(root);
    update();
  };

  /* ---------- Mega menu ---------- */
  MrHeader.prototype.setupMega = function () {
    var self = this, root = this.root;
    this.navbar = $('[data-mrh-navbar]', root);
    if (!this.navbar) return;
    this.items = $$('[data-mrh-item]', root);
    this.panels = {};
    $$('[data-mrh-panel]', root).forEach(function (p) { self.panels[p.dataset.mrhPanel] = p; });

    this.items.forEach(function (item) {
      var key = item.dataset.mrhItem;
      var trigger = item.querySelector('.mrh-nav__link');
      if (canHover) {
        item.addEventListener('mouseenter', function () { self.schedule('open', function () { self.open(key); }, self.openKey ? 40 : 120); });
      }
      trigger.addEventListener('click', function (e) {
        if (trigger.tagName === 'BUTTON' || (!canHover && self.openKey !== key)) {
          e.preventDefault();
          self.openKey === key ? self.close() : self.open(key);
        }
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && trigger.tagName === 'BUTTON')) {
          e.preventDefault(); self.open(key);
          var first = self.panels[key] && self.panels[key].querySelector('a, button');
          if (first) first.focus();
        }
      });
    });

    // close when leaving nav + panel area
    if (canHover) {
      this.navbar.addEventListener('mouseleave', function () { self.schedule('open', function () { self.close(); }, 180); });
      this.navbar.addEventListener('mouseenter', function () { self.prefetchDefaults(); }, { once: true });
      // plain menu items (no panel) close the open panel
      $$('.mrh-nav__item:not([data-mrh-item])', root).forEach(function (it) {
        it.addEventListener('mouseenter', function () { self.schedule('open', function () { self.close(); }, 120); });
      });
      $$('.mrh-utils', root).forEach(function (u) { u.addEventListener('mouseenter', function () { self.schedule('open', function () { self.close(); }, 120); }); });
    }

    Object.keys(this.panels).forEach(function (key) {
      var panel = self.panels[key];
      panel.addEventListener('mouseenter', function () { clearTimeout(self.timers.open); });
      // hover / focus on a collection tile or chip → swap products
      panel.addEventListener('mouseover', function (e) {
        var a = e.target.closest('[data-mrh-col]');
        if (!a || !panel.contains(a)) return;
        self.schedule('col', function () { self.activate(panel, a); }, 70);
      });
      panel.addEventListener('focusin', function (e) {
        var a = e.target.closest('[data-mrh-col]');
        if (a) self.activate(panel, a);
      });
      // tiles scroller arrows
      var wrap = $('[data-mrh-tiles-wrap]', panel);
      if (wrap) {
        var track = $('[data-mrh-tiles]', wrap);
        var upd = function () { self.updateArrows(wrap, track); };
        track.addEventListener('scroll', upd, { passive: true });
        $$('[data-mrh-scroll]', wrap).forEach(function (b) {
          b.addEventListener('click', function () {
            track.scrollBy({ left: parseInt(b.dataset.mrhScroll, 10) * track.clientWidth * 0.8, behavior: 'smooth' });
          });
        });
        // vertical wheel → horizontal scroll on tiles
        track.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && track.scrollWidth > track.clientWidth) {
            e.preventDefault(); track.scrollLeft += e.deltaY;
          }
        }, { passive: false });
      }
    });

    var overlay = $('[data-mrh-overlay]', root);
    overlay && overlay.addEventListener('click', function () { self.close(); self.closeDrawer(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.close(); self.closeDropdowns(); self.closeDrawer(); self.closeSearch && self.closeSearch(); }
    });
    document.addEventListener('click', function (e) {
      if (self.openKey && !self.navbar.contains(e.target)) self.close();
    });
  };

  MrHeader.prototype.schedule = function (name, fn, ms) {
    clearTimeout(this.timers[name]);
    this.timers[name] = setTimeout(fn, ms);
  };

  MrHeader.prototype.open = function (key) {
    if (this.openKey === key) return;
    var panel = this.panels[key];
    if (!panel) return;
    this.close(true);
    this.closeDropdowns();
    this.closeSearch && this.closeSearch();
    this.openKey = key;
    panel.hidden = false;
    this.items.forEach(function (it) {
      var on = it.dataset.mrhItem === key;
      it.classList.toggle('is-open', on);
      var t = it.querySelector('[aria-expanded]'); if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    this.root.classList.add('is-mega-open');
    var current = panel.querySelector('[data-mrh-col].is-active') || panel.querySelector('[data-mrh-col]');
    if (current) this.activate(panel, current, true);
    else this.setStageEmpty(panel);
    var wrap = $('[data-mrh-tiles-wrap]', panel);
    if (wrap) this.updateArrows(wrap, $('[data-mrh-tiles]', wrap));
  };

  MrHeader.prototype.close = function (silent) {
    clearTimeout(this.timers.col);
    if (!this.openKey) return;
    var p = this.panels[this.openKey]; if (p) p.hidden = true;
    this.openKey = null;
    this.items.forEach(function (it) {
      it.classList.remove('is-open');
      var t = it.querySelector('[aria-expanded]'); if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!silent) this.root.classList.remove('is-mega-open');
  };

  MrHeader.prototype.updateArrows = function (wrap, track) {
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    wrap.classList.toggle('can-prev', track.scrollLeft > 2);
    wrap.classList.toggle('can-next', track.scrollLeft < max);
  };

  MrHeader.prototype.activate = function (panel, el, force) {
    var url = el.getAttribute('data-mrh-col');
    var title = el.getAttribute('data-mrh-col-title') || '';
    var isChip = el.classList.contains('mrh-chip');
    var stage = $('[data-mrh-stage]', panel);
    if (!stage) return;
    if (!force && stage.dataset.current === url) return;

    if (isChip) {
      $$('.mrh-chip', panel).forEach(function (c) { c.classList.toggle('is-active', c === el); });
    } else {
      $$('[data-mrh-tiles] [data-mrh-col], .mrh-tile', panel).forEach(function (t) { t.classList.toggle('is-active', t === el); });
      // sub-collection chips (grandchildren)
      var chipsBox = $('[data-mrh-chips]', stage);
      if (chipsBox) {
        var cell = el.closest('.mrh-tiles__cell');
        var tpl = cell && cell.querySelector('template[data-mrh-subs]');
        if (tpl) { chipsBox.innerHTML = ''; chipsBox.appendChild(tpl.content.cloneNode(true)); chipsBox.hidden = false; }
        else { chipsBox.innerHTML = ''; chipsBox.hidden = true; }
      }
    }

    var titleEl = $('[data-mrh-stage-title]', stage), allEl = $('[data-mrh-stage-all]', stage);
    if (titleEl) { titleEl.textContent = title; titleEl.href = el.getAttribute('href') || url; }
    if (allEl) allEl.href = el.getAttribute('href') || url;
    stage.dataset.current = url;
    this.loadInto(stage, url);
  };

  MrHeader.prototype.setStageEmpty = function (panel) {
    var host = $('[data-mrh-products]', panel);
    if (host) host.innerHTML = '';
  };

  MrHeader.prototype.loadInto = function (stage, url) {
    var self = this, host = $('[data-mrh-products]', stage);
    if (!host || !url) return;
    var token = ++this.reqToken;
    var cached = productCache.has(url);
    if (!cached) {
      var sk = '<div class="mrh-skel" aria-hidden="true">';
      for (var i = 0; i < Math.min(this.limit, 8); i++) sk += '<span></span>';
      host.innerHTML = sk + '</div>';
    }
    fetchProducts(url, this.sectionId).then(function (html) {
      if (token !== self.reqToken || stage.dataset.current !== url) return;
      if (!html) { host.innerHTML = '<p class="mrh-products__empty">Could not load products.</p>'; return; }
      host.innerHTML = html;
      var list = host.firstElementChild;
      if (list) {
        $$('.mrh-card', list).forEach(function (c, i) { if (i >= self.limit) c.remove(); });
        self.markWishlist(list);
        self.addRowArrows(host, list);
      }
    });
  };

  MrHeader.prototype.prefetchDefaults = function () {
    var self = this;
    var run = function () {
      Object.keys(self.panels).forEach(function (k) {
        var a = self.panels[k].querySelector('[data-mrh-col].is-active') || self.panels[k].querySelector('[data-mrh-col]');
        if (a) fetchProducts(a.getAttribute('data-mrh-col'), self.sectionId);
      });
    };
    (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(run);
  };

  var ARROW_SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 5l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  MrHeader.prototype.addRowArrows = function (host, list) {
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'mrh-parrow mrh-parrow--prev'; next.className = 'mrh-parrow mrh-parrow--next';
    prev.setAttribute('aria-label', 'Previous products'); next.setAttribute('aria-label', 'Next products');
    prev.innerHTML = next.innerHTML = ARROW_SVG;
    host.appendChild(prev); host.appendChild(next);
    function upd() {
      var max = list.scrollWidth - list.clientWidth - 2;
      host.classList.toggle('can-prev', list.scrollLeft > 2);
      host.classList.toggle('can-next', list.scrollLeft < max);
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth, behavior: 'smooth' }); });
    list.addEventListener('scroll', upd, { passive: true });
    requestAnimationFrame(upd);
    $$('img', list).forEach(function (im) { if (!im.complete) im.addEventListener('load', upd, { once: true }); });
  };

  /* ---------- Wishlist (local) + quick add to cart ---------- */
  var WISH_KEY = 'mrh-wishlist';
  function getWish() { try { return JSON.parse(store('get', WISH_KEY) || '[]'); } catch (e) { return []; } }
  MrHeader.prototype.markWishlist = function (scope) {
    var w = getWish();
    $$('[data-mrh-wish]', scope).forEach(function (b) {
      var on = w.indexOf(b.dataset.mrhWish) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };
  MrHeader.prototype.setupCardActions = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var wish = e.target.closest('[data-mrh-wish]');
      if (wish) {
        e.preventDefault();
        var w = getWish(), h = wish.dataset.mrhWish, i = w.indexOf(h);
        if (i > -1) w.splice(i, 1); else w.push(h);
        store('set', WISH_KEY, JSON.stringify(w));
        self.markWishlist(self.root);
        document.dispatchEvent(new CustomEvent('mrh:wishlist', { detail: { items: w } }));
        return;
      }
      var add = e.target.closest('[data-mrh-add]');
      if (add) {
        e.preventDefault();
        add.classList.add('is-loading');
        var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(add.dataset.mrhAdd, 10), quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            add.classList.remove('is-loading'); add.classList.add('is-added');
            setTimeout(function () { add.classList.remove('is-added'); }, 1600);
            self.refreshCart && self.refreshCart();
            document.dispatchEvent(new CustomEvent('mrh:cart-added', { detail: { variantId: add.dataset.mrhAdd } }));
          })
          .catch(function (err) {
            add.classList.remove('is-loading');
            alert((err && (err.description || err.message)) || 'Could not add to cart');
          });
      }
    });
  };

  /* ---------- Country / account dropdowns ---------- */
  MrHeader.prototype.setupDropdowns = function () {
    var self = this;
    this.dds = $$('[data-mrh-dd]', this.root);
    this.dds.forEach(function (dd) {
      var btn = $('[data-mrh-dd-btn]', dd), panel = $('[data-mrh-dd-panel]', dd);
      if (!btn || !panel) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = panel.hidden;
        self.closeDropdowns();
        self.close();
        if (willOpen) self.openDropdown(dd);
      });
      if (canHover && !dd.classList.contains('mrh-geo')) {
        dd.addEventListener('mouseenter', function () { clearTimeout(dd._t); self.closeDropdowns(dd); self.openDropdown(dd); });
        dd.addEventListener('mouseleave', function () { dd._t = setTimeout(function () { self.closeDropdown(dd); }, 200); });
      }
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    document.addEventListener('click', function () { self.closeDropdowns(); });
  };
  MrHeader.prototype.openDropdown = function (dd) {
    var panel = $('[data-mrh-dd-panel]', dd); if (!panel) return;
    panel.hidden = false; dd.classList.add('is-open');
    var b = $('[data-mrh-dd-btn]', dd); b && b.setAttribute('aria-expanded', 'true');
    var f = $('[data-mrh-country-filter]', panel); if (f && canHover) setTimeout(function () { f.focus(); }, 30);
  };
  MrHeader.prototype.closeDropdown = function (dd) {
    var panel = $('[data-mrh-dd-panel]', dd); if (!panel) return;
    panel.hidden = true; dd.classList.remove('is-open');
    var b = $('[data-mrh-dd-btn]', dd); b && b.setAttribute('aria-expanded', 'false');
  };
  MrHeader.prototype.closeDropdowns = function (except) {
    var self = this;
    (this.dds || []).forEach(function (dd) { if (dd !== except) self.closeDropdown(dd); });
    this.restoreGeoPanel && this.restoreGeoPanel();
  };

  /* ---------- Country & currency (Shopify Markets) ---------- */
  MrHeader.prototype.setupGeo = function () {
    var self = this, root = this.root;
    var form = $('.mrh-geo__form', root);
    if (!form) return;
    var input = $('[data-mrh-country-input]', form);
    var current = (root.dataset.currentCountry || '').toUpperCase();
    var available = $$('[data-mrh-country]', form).map(function (b) { return b.dataset.mrhCountry.toUpperCase(); });

    function submitCountry(code) {
      if (!code || code.toUpperCase() === current) { self.closeDropdowns(); return; }
      input.value = code;
      form.submit();
    }

    $$('[data-mrh-country]', form).forEach(function (b) {
      b.addEventListener('click', function () { store('set', GEO_KEY, 'manual'); submitCountry(b.dataset.mrhCountry); });
    });

    var filter = $('[data-mrh-country-filter]', root);
    if (filter) {
      filter.addEventListener('input', function () {
        var q = filter.value.trim().toLowerCase();
        $$('.mrh-geo__list li', root).forEach(function (li) { li.hidden = q && li.dataset.name.indexOf(q) === -1; });
      });
    }

    // Mobile: show the country list as a bottom sheet from the drawer
    var geoDd = $('.mrh-geo', root), geoPanel = geoDd && $('[data-mrh-dd-panel]', geoDd);
    var openFromDrawer = $('[data-mrh-geo-open]', root);
    if (openFromDrawer && geoPanel) {
      openFromDrawer.addEventListener('click', function (e) {
        e.stopPropagation();
        self.closeDrawer();
        root.appendChild(geoPanel);
        geoPanel.classList.add('mrh-dd--sheet');
        geoPanel.hidden = false;
        root.classList.add('is-drawer-open', 'is-sheet-open');
      });
      this.restoreGeoPanel = function () {
        if (geoPanel.parentNode !== geoDd) {
          geoPanel.hidden = true;
          geoPanel.classList.remove('mrh-dd--sheet');
          geoDd.appendChild(geoPanel);
          root.classList.remove('is-sheet-open');
          if (!root.classList.contains('is-drawer-real-open')) root.classList.remove('is-drawer-open');
        }
      };
    }

    // Auto-detect visitor country once (manual choice is never overridden)
    if (root.dataset.autoGeo !== 'true' || store('get', GEO_KEY)) return;
    if (window.Shopify && window.Shopify.designMode) return; // not inside the theme editor
    if (navigator.webdriver) return;
    fetch('/browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        store('set', GEO_KEY, 'auto');
        var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!detected) return;
        detected = detected.toUpperCase();
        if (detected !== current && available.indexOf(detected) > -1) submitCountry(detected);
      })
      .catch(function () {});
  };

  /* ---------- Search (niceonesa-style) ---------- */
  var RECENT_KEY = 'mrh-recent-searches';
  function getRecent() { try { return JSON.parse(store('get', RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function saveSearch(term) {
    term = String(term || '').trim();
    if (term.length < 2 || term.length > 60) return;
    var list = getRecent().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    store('set', RECENT_KEY, JSON.stringify(list.slice(0, 10)));
  }
  // remember searches made on the search results page (from any search box)
  try {
    if (/\/search\/?$/.test(location.pathname)) {
      var qp = new URLSearchParams(location.search).get('q');
      if (qp) saveSearch(qp);
    }
  } catch (e) {}

  var SEARCH_SVG = '<svg class="mrh-ico mrh-ico--search" viewBox="0 0 16 16" aria-hidden="true"><circle cx="7" cy="7" r="5.3" fill="none" stroke="currentColor" stroke-width="1.2"/><path d="M11 11l3.6 3.6" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';

  MrHeader.prototype.setupSearch = function () {
    var self = this;
    this.searchBoxes = [];
    $$('[data-mrh-search]', this.root).forEach(function (box) { self.searchBoxes.push(self.setupSearchBox(box)); });
    document.addEventListener('click', function (e) {
      self.searchBoxes.forEach(function (sb) { if (sb && sb.isOpen() && !sb.box.contains(e.target)) sb.close(); });
    });
  };
  MrHeader.prototype.closeSearch = function () {
    (this.searchBoxes || []).forEach(function (sb) { if (sb && sb.isOpen()) sb.close(); });
  };

  MrHeader.prototype.setupSearchBox = function (box) {
    var self = this, root = this.root;
    var form = $('[data-mrh-search-form]', box);
    var input = $('[data-mrh-search-input]', box);
    var ph = $('[data-mrh-ph]', box);
    var clear = $('[data-mrh-search-clear]', box);
    var panel = $('[data-mrh-search-panel]', box);
    var def = $('[data-mrh-search-default]', box);
    var results = $('[data-mrh-search-results]', box);
    var popular = $('[data-mrh-popular]', box);
    var prodHost = $('[data-mrh-search-products]', box);
    if (!input || !panel) return null;
    var base = root.dataset.searchUrl || '/search/suggest';
    var moneyFormat = decodeHtml(root.dataset.moneyFormat || '$' + '{{amount}}');
    var searchRoot = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search';
    var t, ctrl, focusIdx = -1, open = false, productsLoaded = false;

    /* rotating placeholder: texts slide up one by one */
    var phItems = ph ? $$('.mrh-search__ph-item', ph) : [];
    if (phItems.length) {
      var cur = 0;
      phItems[0].classList.add('is-in');
      if (phItems.length > 1) {
        setInterval(function () {
          if (box.classList.contains('is-typing') || document.hidden) return;
          var prev = phItems[cur];
          cur = (cur + 1) % phItems.length;
          prev.classList.remove('is-in'); prev.classList.add('is-out');
          phItems[cur].classList.remove('is-out'); phItems[cur].classList.add('is-in');
          setTimeout(function () { prev.classList.remove('is-out'); }, 450);
        }, 2600);
      }
      ph.addEventListener('click', function () { input.focus(); });
    }
    function syncTyping() {
      var has = input.value.length > 0;
      box.classList.toggle('is-typing', has);
      if (clear) clear.hidden = !has;
    }

    function renderPopular() {
      if (!popular) return;
      var defaults = (popular.dataset.defaults || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var list = getRecent();
      defaults.forEach(function (d) {
        if (list.length < 10 && !list.some(function (x) { return x.toLowerCase() === d.toLowerCase(); })) list.push(d);
      });
      list = list.slice(0, 10);
      var wrap = popular.closest('[data-mrh-popular-wrap]');
      if (wrap) wrap.hidden = !list.length;
      popular.innerHTML = list.map(function (k) {
        return '<a class="mrh-chip2" href="' + searchRoot + '?q=' + encodeURIComponent(k) + '&options%5Bprefix%5D=last" data-mrh-save="' + esc(k) + '">' + esc(k) + '</a>';
      }).join('');
    }

    function loadProducts() {
      if (productsLoaded || !prodHost || !prodHost.dataset.url) return;
      productsLoaded = true;
      var sk = '<div class="mrh-skel mrh-skel--search" aria-hidden="true">';
      for (var i = 0; i < 5; i++) sk += '<span></span>';
      prodHost.innerHTML = sk + '</div>';
      fetchProducts(prodHost.dataset.url, self.sectionId).then(function (html) {
        if (!html) { prodHost.innerHTML = ''; productsLoaded = false; return; }
        prodHost.innerHTML = html;
        var list = prodHost.firstElementChild;
        if (list) {
          $$('.mrh-card', list).forEach(function (c, i) { if (i >= 10) c.remove(); });
          self.markWishlist(list);
          self.addRowArrows(prodHost, list);
        }
      });
    }

    function openPanel() {
      if (open) return;
      open = true;
      self.close(); self.closeDropdowns();
      self.searchBoxes && self.searchBoxes.forEach(function (sb) { if (sb && sb.box !== box && sb.isOpen()) sb.close(); });
      box.classList.add('is-open');
      root.classList.add('is-search-open');
      panel.hidden = false;
      renderPopular();
      showState();
      loadProducts();
    }
    function closePanel() {
      if (!open) return;
      open = false;
      box.classList.remove('is-open');
      panel.hidden = true;
      focusIdx = -1;
      var anyOpen = (self.searchBoxes || []).some(function (sb) { return sb && sb.isOpen(); });
      if (!anyOpen) root.classList.remove('is-search-open');
    }
    function showState() {
      var q = input.value.trim();
      if (q.length) { def.hidden = true; results.hidden = false; }
      else { def.hidden = false; results.hidden = true; results.innerHTML = ''; }
    }

    function priceHtml(p) {
      var price = parseFloat(p.price), was = parseFloat(p.compare_at_price_max || p.compare_at_price_min || 0);
      var html = '';
      if (was > price) {
        var pct = Math.round((was - price) * 100 / was);
        html += '<s class="mrh-sr__was">' + esc(formatMoney(was, moneyFormat)) + '</s>';
        html += '<span class="mrh-sr__nowrow"><span class="mrh-sr__price is-sale">' + esc(formatMoney(price, moneyFormat)) + '</span><span class="mrh-card__off">-' + pct + '%</span></span>';
      } else {
        html += '<span class="mrh-sr__nowrow"><span class="mrh-sr__price">' + esc(formatMoney(price, moneyFormat)) + '</span></span>';
      }
      return html;
    }
    function boldPrefix(text, q) {
      var i = text.toLowerCase().indexOf(q.toLowerCase());
      if (i < 0) return esc(text);
      return esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + q.length)) + '</b>' + esc(text.slice(i + q.length));
    }
    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], cols = r.collections || [], queries = r.queries || [];
      var sugg = queries.map(function (s) { return s.text; });
      if (!sugg.some(function (s) { return s.toLowerCase() === q.toLowerCase(); })) sugg.unshift(q);
      var html = '<div class="mrh-sr__group"><p class="mrh-sp__title">Suggestions</p><ul class="mrh-sr__list" role="list">';
      html += sugg.slice(0, 8).map(function (s) {
        return '<li><a class="mrh-sr__item mrh-sr__sugg" href="' + searchRoot + '?q=' + encodeURIComponent(s) + '&options%5Bprefix%5D=last" data-mrh-save="' + esc(s) + '">' + SEARCH_SVG + '<span>' + boldPrefix(s, q) + '</span></a></li>';
      }).join('');
      html += cols.slice(0, 4).map(function (c) {
        return '<li><a class="mrh-sr__item mrh-sr__sugg" href="' + esc(c.url) + '" data-mrh-save="' + esc(q) + '">' + SEARCH_SVG + '<span>' + boldPrefix(c.title, q) + ' <b>in Collections</b></span></a></li>';
      }).join('');
      html += '</ul></div>';
      if (products.length) {
        html += '<div class="mrh-sr__group"><p class="mrh-sp__title">Products</p><ul class="mrh-sr__list" role="list">' + products.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          return '<li><a class="mrh-sr__item mrh-sr__prod" href="' + esc(p.url) + '" data-mrh-save="' + esc(q) + '">' +
            '<span class="mrh-sr__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="eager" width="40" height="40">' : '') + '</span>' +
            '<span class="mrh-sr__info"><span class="mrh-sr__vendor">' + esc(p.vendor || '') + '</span><span class="mrh-sr__title">' + esc(p.title) + '</span></span>' +
            '<span class="mrh-sr__prices">' + priceHtml(p) + '</span></a></li>';
        }).join('') + '</ul></div>';
      } else {
        html += '<p class="mrh-sr__empty">No products found for “' + esc(q) + '”</p>';
      }
      html += '<a class="mrh-sr__all" href="' + searchRoot + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last" data-mrh-save="' + esc(q) + '">View all results for “' + esc(q) + '”</a>';
      results.innerHTML = html;
      focusIdx = -1;
    }
    function query() {
      var q = input.value.trim();
      showState();
      if (!q.length) return;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = base + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); })
        .then(function (d) { if (input.value.trim() === q) render(q, d); }).catch(function () {});
    }

    input.addEventListener('focus', function () { openPanel(); });
    input.addEventListener('click', function () { openPanel(); });
    input.addEventListener('input', function () {
      syncTyping(); openPanel(); showState();
      clearTimeout(t); t = setTimeout(query, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(); input.blur(); return; }
      var items = $$('.mrh-sr__item, .mrh-sr__all', results);
      if (results.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        focusIdx = (focusIdx + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (it, i) { it.classList.toggle('is-focus', i === focusIdx); });
        items[focusIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && focusIdx > -1) {
        e.preventDefault();
        saveSearch(items[focusIdx].dataset.mrhSave || input.value);
        window.location.href = items[focusIdx].href;
      }
    });
    form && form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      saveSearch(q);
    });
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('[data-mrh-save]');
      if (a) saveSearch(a.dataset.mrhSave);
    });
    clear && clear.addEventListener('click', function () {
      input.value = ''; syncTyping(); showState(); input.focus();
    });
    syncTyping();

    return { box: box, close: closePanel, isOpen: function () { return open; } };
  };

  /* ---------- Visitor location (city / state by IP) ---------- */
  var LOC_KEY = 'mrh-loc-v1';
  MrHeader.prototype.setupLocation = function () {
    var root = this.root;
    if (root.dataset.autoLocation !== 'true') return;
    var fmt = root.dataset.locationFormat || 'region';
    var current = (root.dataset.currentCountry || '').toUpperCase();

    function label(loc) {
      var city = (loc.city || '').trim(), region = (loc.region || '').trim();
      if (fmt === 'city') return city || region;
      if (fmt === 'city_region') return city && region && city !== region ? city + ' - ' + region : (city || region);
      return region || city;
    }
    function apply(loc) {
      if (!loc || !loc.cc) return;
      var place = label(loc);
      var countryName = loc.country || loc.cc;
      var det = $('[data-mrh-detected]', root), detText = $('[data-mrh-detected-text]', root);
      if (det && detText && place) {
        detText.textContent = 'Your location: ' + place + ', ' + countryName;
        det.hidden = false;
      }
      // only replace the label when the visitor is in the selected shipping country
      if (place && loc.cc.toUpperCase() === current) {
        $$('[data-mrh-place]', root).forEach(function (el) { el.textContent = place; el.title = place + ', ' + countryName; });
      }
    }
    var cached = null;
    try { cached = JSON.parse(store('get', LOC_KEY) || 'null'); } catch (e) {}
    if (cached && cached.t && Date.now() - cached.t < 7 * 864e5) { apply(cached); return; }

    function norm(cc, country, region, city) {
      return { cc: (cc || '').toUpperCase(), country: country || '', region: region || '', city: city || '', t: Date.now() };
    }
    var providers = [
      function () { return fetch('https://get.geojs.io/v1/ip/geo.json').then(function (r) { return r.json(); })
        .then(function (d) { return norm(d.country_code, d.country, d.region, d.city); }); },
      function () { return fetch('https://ipapi.co/json/').then(function (r) { return r.json(); })
        .then(function (d) { if (d.error) throw d; return norm(d.country_code, d.country_name, d.region, d.city); }); },
      function () { return fetch('https://ipwho.is/').then(function (r) { return r.json(); })
        .then(function (d) { if (d.success === false) throw d; return norm(d.country_code, d.country, d.region, d.city); }); }
    ];
    (function next(i) {
      if (i >= providers.length) return;
      providers[i]().then(function (loc) {
        if (!loc.cc || (!loc.region && !loc.city)) return next(i + 1);
        store('set', LOC_KEY, JSON.stringify(loc));
        apply(loc);
      }).catch(function () { next(i + 1); });
    })(0);
  };

  /* ---------- Mobile drawer ---------- */
  MrHeader.prototype.setupDrawer = function () {
    var self = this, root = this.root;
    this.drawer = $('[data-mrh-drawer]', root);
    this.drawerBtn = $('[data-mrh-drawer-open]', root);
    if (!this.drawer || !this.drawerBtn) return;
    this.drawerBtn.addEventListener('click', function () { self.openDrawer(); });
    $$('[data-mrh-drawer-close]', root).forEach(function (b) { b.addEventListener('click', function () { self.closeDrawer(); }); });
  };
  MrHeader.prototype.openDrawer = function () {
    this.root.classList.add('is-drawer-open', 'is-drawer-real-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.drawerBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var c = $('[data-mrh-drawer-close]', this.drawer); c && c.focus();
  };
  MrHeader.prototype.closeDrawer = function () {
    if (!this.drawer) return;
    this.root.classList.remove('is-drawer-real-open');
    if (!this.root.classList.contains('is-sheet-open')) this.root.classList.remove('is-drawer-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.drawerBtn && this.drawerBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  };

  /* ---------- Cart count (stays in sync with any theme cart) ---------- */
  MrHeader.prototype.setupCart = function () {
    var root = this.root;
    function setCount(n) {
      $$('[data-mrh-cart-count]', root).forEach(function (el) { el.textContent = n; el.hidden = !n; });
    }
    var pending, self = this;
    function refresh() {
      clearTimeout(pending);
      pending = setTimeout(function () {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
      }, 250);
    }
    ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added', 'theme:cart:change'].forEach(function (ev) {
      document.addEventListener(ev, refresh);
    });
    if ('PerformanceObserver' in window) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (e) {
            if (/\/cart\/(add|change|update|clear)/.test(e.name)) refresh();
          });
        }).observe({ type: 'resource', buffered: false });
      } catch (e) {}
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    self.refreshCart = refresh;
  };

  /* ---------- boot ---------- */
  function boot(scope) {
    $$('[data-mrh]', scope).forEach(function (el) {
      if (el._mrh) return;
      el._mrh = new MrHeader(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-mrh-panel]');
    var root = e.target.closest && e.target.closest('[data-mrh]');
    if (panel && root && root._mrh) root._mrh.open(panel.dataset.mrhPanel);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-mrh]');
    if (root && root._mrh) root._mrh.close();
  });
})();
